module.exports = __webpack_public_path__ + "img/quiz-music.872800da.svg";